/**
 * 상점/벌점 현황 검색 조건 화면
 */
import React, { Component } from 'react';
import { Navbar, ListGroup, Button, Form, Modal, InputGroup, Row, Col, Container } from 'react-bootstrap';
import { hakgwaList, banArr, sc_rule, udfSetSearchCondition, udfSetScInfo } from '../../common/usr/stdtList';
import { udfAutoLogin, url, udfInlineLoading, udfNoneLoading } from '../../common/common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleLeft, faCalendarAlt, faSearch, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import enUS from 'date-fns/locale/en-US';
import $ from 'jquery';
import loader from '../../imgs/ajax-loader.gif';
import SideMenuCmp from './SideMenuCmp';

registerLocale('enUs', enUS);

let firstIndex = 0;	// 불러 올 시작 레코드
const recordCountPerPage = 10;	// 한번에 불러 올 레코드 개수
let isMore = true;	// 불러 올 레코드 존재 여부
let isRunning = false;

let that = this;

class RuleSearchCmp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      SF_HAKGWA: sc_rule.SF_HAKGWA,
      SF_GRADE: sc_rule.SF_GRADE,
      SF_START_BAN: sc_rule.SF_START_BAN,
      SF_END_BAN: sc_rule.SF_END_BAN,
      SF_SDATE: sc_rule.SF_SDATE,
      SF_EDATE: sc_rule.SF_EDATE,
      SF_KIND: sc_rule.SF_KIND,
      SF_KIND_SP: sc_rule.SF_KIND_SP,
      SF_KIND_EP: sc_rule.SF_KIND_EP,
      SF_CLRL_CD: sc_rule.SF_CLRL_CD,
      SF_CLRL_NM: sc_rule.SF_CLRL_NM,

      // 지도(상벌점) modal
      SF_CL_CD: sc_rule.SF_CL_CD,
      SF_RL_searchKeyword: sc_rule.SF_RL_searchKeyword,

      // bootstrap Alert 변수
      alertShow: false,
      alertClickNo: null,
      alertClickYes: null,
      alertClickOk: null,
      alertMessage: null,

      rlList: [],
      CLList: [],
      rlAlertShow: false,
      usrInfo: null,
      clGuNm: { B: '상점', R: '벌점', G: '회복', S: '차감' },
    };
  }

  componentDidMount = () => {
    // 자동 로그인 체크
    udfAutoLogin(this).then((data) => {
      if (data !== null && data.userSe === 'STDT') {
        this.props.history.push('/stdt/ruleList');
      } else if (data !== null && data.userSe === 'USR') {
        this.setState({ usrInfo: data, clGuNm: { B: data.BLUE_NM, R: data.RED_NM, G: '회복', S: '차감' } });
      } else {
        this.props.history.push('/');
      }
    });
    window.addEventListener('scroll', this.modalHandleScroll);
  }

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.modalHandleScroll);
  }

  componentDidUpdate = () => {
    const { rlAlertShow } = this.state;
    if (rlAlertShow) {
      document.getElementById('rlModalBody').addEventListener('scroll', this.modalHandleScroll);
    }
  }

  modalHandleScroll = () => {
    let bodyId = 'rlModalBody';

    if ($('#' + bodyId)[0] !== undefined &&
      $('#' + bodyId).scrollTop() + $('#' + bodyId).innerHeight() >= $('#' + bodyId)[0].scrollHeight &&
      isMore) {
      this.fn_searchRL('N', '');
    }
  }

  removeEventValue = () => {
    if (document.getElementById('rlModalBody') !== null) {
      document.getElementById('rlModalBody').removeEventListener('scroll', this.modalHandleScroll);

      firstIndex = 0;
      isMore = true;
      isRunning = false;
    }
  }

  handleChange = (e) => {
    udfSetSearchCondition('rule', e.target.name, e.target.value);
  }

  // bootstrap Alert close
  alertClose = (key) => {
    this.removeEventValue();
    this.setState({
      [key]: false,
      // 검색 조건 초기화
      SF_CL_CD: '',
      SF_RL_searchKeyword: '',
    });
  }

  // 지도(상벌점) 항목 조회
  fn_searchRL = (clearYn, v_CL_CD) => {
    if (!this.state.usrInfo) return;

    if (clearYn === 'Y') {
      firstIndex = 0;
      isMore = true;
      $(window).scrollTop(0);
    }

    that = this;

    if (isMore && !isRunning) {
      isRunning = true;
      udfInlineLoading();

      $.ajax({
        url: url + '/sli/rule/selectRLListPUP.do',
        type: 'GET',
        dataType: 'jsonp',
        data: {
          isMobile: 'Y',
          firstIndex: firstIndex,
          recordCountPerPage: recordCountPerPage,
          SF_CL_CD: v_CL_CD,
          searchKeyword: $('input[name="SF_RL_searchKeyword"]').val()
        },
        success: function (data) {
          udfNoneLoading();

          if (!data.success)
            that.componentDidMount();
          else {
            let resultList = [];

            if (data.resultList !== undefined && data.resultList !== '') {
              var idx = firstIndex;
              $.each(data.resultList, function (i, val) {
                idx++;

                resultList.push({
                  CL_GU: val.CL_GU,
                  CL_GU_NM: that.state.clGuNm[val.CL_GU],
                  CL_NM: val.CL_NM,
                  CL_CD: val.CL_CD,
                  RL_CD: val.RL_CD,
                  RL_DESC: val.RL_DESC,
                  POINT: val.POINT,
                  SELF_YN: val.SELF_YN,
                  ONLY_SELF_YN: val.ONLY_SELF_YN
                });
              });
            }

            if (idx - firstIndex !== recordCountPerPage) isMore = false;
            firstIndex += recordCountPerPage;

            let cllist = [];
            if (data.CLList !== undefined && data.CLList !== '') {
              $.each(data.CLList, function (i, val) {
                cllist.push({
                  CL_CD: val.CL_CD,
                  CL_NM: val.CL_NM,
                  CL_GU: val.CL_GU,
                  CL_GU_NM: that.state.clGuNm[val.CL_GU],
                });
              });
            }

            if (clearYn === 'N') resultList = that.state.rlList.concat(resultList);

            that.setState({
              rlList: resultList,
              CLList: cllist,
              rlAlertShow: true
            });
          }

          isRunning = false;
        },
        error: function (jqXHR, status, error) {
          isRunning = false;
          that.componentDidMount();
        }
      });
    }
  }

  // 지도(상벌점) 선택
  fn_select_rl = (data) => {
    this.removeEventValue();

    udfSetSearchCondition('rule', 'SF_CLRL_CD', data.CL_CD + data.RL_CD);
    udfSetSearchCondition('rule', 'SF_CLRL_NM', data.RL_DESC);

    this.setState({
      rlAlertShow: false,
      SF_CLRL_CD: data.CL_CD + data.RL_CD,
      SF_CLRL_NM: data.RL_DESC
    })
  }

  // 0 채우기
  fn_fillZero = (val, length) => {
    let addZero = '';

    val = val.toString();

    if (val.length < length) {
      const diff = length - val.length;
      for (let i = 0; i < diff; i++) addZero += '0';
    }

    return addZero + val;
  }

  handleDateInput = (name, date) => {
    let val = date.getFullYear() + '-' + this.fn_fillZero(date.getMonth() + 1, 2) + '-' + this.fn_fillZero(date.getDate(), 2);
    udfSetSearchCondition('rule', name, val);

    this.setState({
      [name]: val
    });
  }

  render() {
    const setHakgwaList = hakgwaList.map((str, idx) => (
      <option value={str} key={idx}>{str}</option>
    ));

    const setBanArr = banArr.map((ban, idx) => (
      <option value={ban} key={idx}>{ban} 반</option>
    ));

    return (
      <>
        {/* to the top */}
        <div className='btn-to-top-b1' onClick={() => $(window).scrollTop(0)}><FontAwesomeIcon icon={faAngleUp} /></div>

        <div className='wrap-loading d-none'>
          <img src={loader} alt='로딩 이미지' />
        </div>

        {/* header */}
        <Navbar fixed='top' className='title'>
          <div className="goBackBtn"><div style={{ color: '#fff' }}><FontAwesomeIcon icon={faArrowCircleLeft} className="btn-home" /></div></div>
          검색조건
          <SideMenuCmp
            history={this.props.history}
            usrInfo={this.state.usrInfo}
            alertShow={this.state.alertShow}
            alertMessage={this.state.alertMessage}
            alertClickOk={this.state.alertClickOk}
            alertClickYes={this.state.alertClickYes}
            alertClickNo={this.state.alertClickNo}
          />
        </Navbar>

        <Container style={{ marginTop: '65px', marginBottom: '4rem' }}>
          <Row>
            <Col>
              <Form.Label>학과</Form.Label>
              <Form.Control as='select' className="bg-light text-muted" name='SF_HAKGWA' defaultValue={this.state.SF_HAKGWA} onChange={this.handleChange}>
                <option value=''>전체</option>
                {setHakgwaList}
              </Form.Control>
            </Col>
            <Col>
              <Form.Label>학년</Form.Label>
              <Form.Control as='select' className="bg-light text-muted" name='SF_GRADE' defaultValue={this.state.SF_GRADE} onChange={this.handleChange}>
                <option value=''>전체</option>
                <option value='1'>1 학년</option>
                <option value='2'>2 학년</option>
                <option value='3'>3 학년</option>
                <option value='4'>4 학년</option>
                <option value='5'>5 학년</option>
                <option value='6'>6 학년</option>
              </Form.Control>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <Form.Label>반 범위</Form.Label>
              <InputGroup>
                <Form.Control as='select' name='SF_START_BAN' className="bg-light text-muted" defaultValue={this.state.SF_START_BAN} onChange={this.handleChange}>
                  {setBanArr}
                </Form.Control>
                <InputGroup.Append>
                  <InputGroup.Text>부터</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
            </Col>
            <Col>
              <Form.Label>&nbsp;</Form.Label>
              <InputGroup>
                <Form.Control as='select' name='SF_END_BAN' className="bg-light text-muted" defaultValue={this.state.SF_END_BAN} onChange={this.handleChange}>
                  {setBanArr}
                </Form.Control>
                <InputGroup.Append>
                  <InputGroup.Text>까지</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col className='fullInputGroup'>
              <Form.Label style={{ display: 'block' }}>기간(시작)</Form.Label>
              <DatePicker
                todayButton={'TODAY'}
                dateFormat='yyyy-MM-dd'
                locale={enUS}
                className='mb-3'
                customInput={
                  <InputGroup>
                    <Form.Control
                      type='text'
                      value={this.state.SF_SDATE}
                      readOnly
                      className="bg-light text-muted"
                    />
                    <InputGroup.Append>
                      <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                    </InputGroup.Append>
                    <InputGroup.Append>
                      <InputGroup.Text>부터</InputGroup.Text>
                    </InputGroup.Append>
                  </InputGroup>
                }
                onChange={(val) => { this.handleDateInput('SF_SDATE', val) }}
              />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col className='fullInputGroup'>
              <Form.Label style={{ display: 'block' }}>기간(종료)</Form.Label>
              <DatePicker
                todayButton={'TODAY'}
                dateFormat='yyyy-MM-dd'
                locale={enUS}
                customInput={
                  <InputGroup>
                    <Form.Control
                      type='text'
                      value={this.state.SF_EDATE}
                      className="bg-light text-muted"
                      readOnly
                    />
                    <InputGroup.Append>
                      <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                    </InputGroup.Append>
                    <InputGroup.Append>
                      <InputGroup.Text>까지</InputGroup.Text>
                    </InputGroup.Append>
                  </InputGroup>
                }
                onChange={(val) => { this.handleDateInput('SF_EDATE', val) }}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Label>구분</Form.Label>
              <Form.Control as='select' className="bg-light text-muted" name='SF_KIND' defaultValue={this.state.SF_KIND} onChange={this.handleChange}>
                <option value=''>전체</option>
                <option value='B'>{this.state.usrInfo ? this.state.usrInfo.BLUE_NM : '상점'}</option>
                <option value='R'>{this.state.usrInfo ? this.state.usrInfo.RED_NM : '벌점'}</option>
                <option value='G'>회복</option>
                <option value='S'>차감</option>
              </Form.Control>
            </Col>
            <Col>
              <Form.Label>점수 범위</Form.Label>
              <InputGroup>
                <Form.Control type='number' name='SF_KIND_SP' className="bg-light text-muted" defaultValue={this.state.SF_KIND_SP} onChange={this.handleChange} />
                <InputGroup.Append>
                  <InputGroup.Text>부터</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
            </Col>
            <Col>
              <Form.Label>&nbsp;</Form.Label>
              <InputGroup>
                <Form.Control type='number' name='SF_KIND_EP' className="bg-light text-muted" defaultValue={this.state.SF_KIND_EP} onChange={this.handleChange} />
                <InputGroup.Append>
                  <InputGroup.Text>까지</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <Form.Label>항목</Form.Label>
              <InputGroup>
                <Form.Control type='text' name='SF_CLRL_CD' className="bg-light text-muted" value={this.state.SF_CLRL_CD} readOnly onChange={this.handleChange} onClick={() => this.fn_searchRL('Y', '')} />
                <InputGroup.Append onClick={() => this.fn_searchRL('Y', '')}>
                  <InputGroup.Text><FontAwesomeIcon icon={faSearch} /></InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <Form.Label>내용</Form.Label>
              <Form.Control as='textarea' row='3' name='SF_CLRL_NM' className="bg-light text-muted" readOnly value={this.state.SF_CLRL_NM} />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <Link to='/usr/ruleRpt' onClick={() => udfSetScInfo('rule', true, false)}>
                <Button className='mt-2 btn btn-height btn-school-life col'>검색</Button>
              </Link>
            </Col>
          </Row>
        </Container>

        {/* 지도(상벌점) modal */}
        <Modal
          show={this.state.rlAlertShow}
          onHide={() => this.alertClose('rlAlertShow')}
          aria-labelledby='rl-contained-modal-title-vcenter'
          animation={false}
          backdropClassName='show'
          centered
          className='customModal'
          size='lg'
        >
          <Modal.Header closeButton>
            <Modal.Title id='rl-contained-modal-title-vcenter'>
              <span className='h5'>지도 세부항목 선택</span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body id='rlModalBody' style={{ padding: '0' }}>
            {
              this.state.CLList.length === 0 ? null :
                this.state.CLList.map((data, idx) => (
                  <Button
                    variant={data.CL_GU === "R" ? "danger" : data.CL_GU === "B" ? "primary" : "info"}
                    className="m-1"
                    onClick={() => { this.fn_searchRL('Y', data.CL_CD); }}
                  >
                    {data.CL_NM}
                  </Button>
                ))
            }

            <InputGroup className='mt-2 mb-3 pl-3 pr-3'>
              <InputGroup.Prepend>
                <InputGroup.Text>검색</InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control
                type='text'
                name='SF_RL_searchKeyword'
                aria-describedby='SF_RL_searchKeyword'
                onChange={(e) => this.handleInputChange(e.target, 'N')}
                className='bg-light text-muted'
              />
              <InputGroup.Prepend onClick={() => this.fn_searchRL('Y', '')}>
                <InputGroup.Text><FontAwesomeIcon icon={faSearch} /></InputGroup.Text>
              </InputGroup.Prepend>
            </InputGroup>

            <ListGroup variant='flush'>
              {
                this.state.rlList.length === 0 ? null :
                  this.state.rlList.map((data, idx) => {
                    return (
                      <ListGroup.Item key={idx} onClick={() => this.fn_select_rl(data)}>
                        <div className='row'>
                          <div className='col-2 pr-0'><span className={data.CL_GU_NM === this.state.usrInfo.BLUE_NM ? 'blue-point' : data.CL_GU_NM === this.state.usrInfo.RED_NM ? 'red-point' : data.CL_GU_NM === '회복' ? 'green-point' : data.CL_GU_NM === '차감' ? 'deduction-point' : ''}>{data.CL_GU_NM}</span></div>
                          <div className='col'>{data.RL_DESC}</div>
                          <div className='col-2 point text-right text-nowrap'>
                            <span style={{ fontSize: "1.4rem" }}>{data.POINT}</span> 점
                          </div>
                          <div className='col-12'>
                            <span className='text-secondary d-inline-block' style={{ fontSize: '.9rem', marginRight: '10px' }}>{`${data.CL_CD}-${data.RL_CD}`}</span>
                            <span className='text-secondary d-inline-block' style={{ fontSize: '.9rem', marginRight: '10px' }}>{data.CL_NM}</span>
                          </div>
                        </div>
                      </ListGroup.Item>
                    );
                  })
              }
            </ListGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='link' onClick={() => { this.alertClose('rlAlertShow') }}>닫기</Button>
          </Modal.Footer>
        </Modal>

      </>
    );
  }
}

export default RuleSearchCmp;